import { Components } from "@thisgorilla/primate-ds";
import { useContext } from "react";
import styled, { useTheme } from "styled-components";

import { CreatePostModalContext } from "../..";
import { useAppSelector } from "../../../../../../../../redux";
import { ImageUploadProps } from "./ImageUpload";

const MediaUpload = ({ fileInputRef }: ImageUploadProps.IProps) => {
  const { typography } = useTheme();
  const { uploadedFiles } = useAppSelector((state) => state.posts);
  const { setImageUploadOpen, setPostContentOrder } = useContext(
    CreatePostModalContext
  );
  const addmore = uploadedFiles.length === 1;

  return (
    <MediaUploadContainer onClick={() => fileInputRef?.current?.click()}>
      <Container $addmore={addmore}>
        <Components.IconButton
          kind="Primary"
          size={addmore ? "Small" : "Large"}
          disabled={false}
          iconType="Image"
          onClick={() => {}}
        />
        <Components.Text
          style={{ tokenStyle: typography.Heading[addmore ? "XS" : "S"] }}
          text="Add images"
          fontWeight="font-weight-semibold"
          lineHeight={addmore ? "line-height-75" : "line-height-400"}
        />
        <Components.Text
          style={{ tokenStyle: typography.Body[addmore ? "XS" : "S"] }}
          text="Or drag and drop here"
          fontWeight="font-weight-semibold"
          lineHeight={addmore ? "line-height-25" : "line-height-50"}
        />
        <ButtonContainer>
          <Components.IconButton
            disabled={false}
            iconType="X"
            kind="Secondary"
            onClick={(e) => {
              e.stopPropagation();
              setImageUploadOpen(false);
              uploadedFiles.length === 0 &&
                setPostContentOrder((prev) =>
                  prev.filter((type) => type !== "image")
                );
            }}
            size="Small"
          />
        </ButtonContainer>
      </Container>
    </MediaUploadContainer>
  );
};

export default MediaUpload;

const MediaUploadContainer = styled.div`
  cursor: pointer;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-m"].value}rem;
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-s"]};
  border: ${({ theme }) => theme.border_width["border-width-thin"].value}rem
    solid ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-secondary"].value};

  &:hover {
    & {
      border-color: ${({ theme }) =>
        theme.Color.border["ui-border-emphasize-brand"].value};
      background: ${({ theme }) =>
        theme.Color.background.brand.subtlest["default-hover"].value};
    }
    & > div {
      & > button {
        background: ${({ theme }) =>
          theme.Color.background.brand.default.value};
      }
      & > label:nth-child(2) {
        color: ${({ theme }) =>
          theme.Color.text["text-emphasize-brand-bolder"].value};
      }
    }
  }
`;

const Container = styled.div<{ $addmore: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["spacing-1"].value}rem;
  padding: ${({ theme, $addmore }) =>
      $addmore ? `${theme.spacing["spacing-6"].value}rem` : "47px"}
    ${({ theme }) => theme.spacing["spacing-4"].value}rem
    ${({ theme, $addmore }) =>
      $addmore ? `${theme.spacing["spacing-2"].value}rem` : "47px"};
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  border: ${({ theme }) => theme.border_width["border-width-thin"].value}rem
    dashed
    ${({ theme }) => theme.Color.border["ui-border-emphasize-brand"].value};
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary-emphasize-hover"].value};

  & > button {
    background: ${({ theme }) =>
      theme.Color.background.brand.subtle.default.value};
  }
`;

const ButtonContainer = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  right: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;
